import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function DiplomatskoIKonzularnoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Diplomatsko i konzularno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Diplomatsko i konzularno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Diplomatsko i konzularno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Diplomatsko i konzularno pravo obuhvata produbljeno
                izučavanje ovog dijela međunarodnog prava. Studentima se ukazuje
                na razvoj diplomatskog prava i izgradnju osnovnih normi iz ove
                oblasti. Poseban akcenat stavlja se na praksu država i
                primjerima iz prakse. Takođe cilj ovog predmeta je da ukaže na
                razlike i sličnosti između bilateralne i multilateralne
                diplomatije kao i da ukaže na rad diplomatskih predstavništava,
                njihov sastav, nadležnosti i osoblje misija. Posebna pažnja
                posvećena je pravilima ponašanja i kodeks diplomatskih
                predstavnika kako bi se osposobili za rad u diplomatskim
                predstavništvima širom svijeta.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon položenog predmeta studenti će biti u mogućnosti da: ukažu
                i objasne izvore međunarodnih pravila koja uređuju diplomatske i
                konzularne odnose; definišu pojmove diplomatskog i konzularnog
                prava; ukažu na značaj i uticaj diplomatskih i konzularnih
                predstavništava na stabilnost na geopolitičkoj sceni kao i na
                uticaj odnosa između država. Ujedno bi student trebao biti u
                mogućnosti da samostalno istraži i analizira relevantnu
                međunarodnu sudsku i arbitražnu praksu te da samostalno rješava
                konkretne problemske situacije povezane s primjenom normi
                diplomatskog i konzularnog prava. Stečene vještine omogućiti će
                studentu da samostalno sačinjava spise koji su od značaja za rad
                diplomatskih i konzularnih predstavništava. Takođe, osim odnosa
                između država studenti će steći znanja o odnosima sa drugim
                subjektima (međunarodne organizacije, Sveta Stolica, Malteški
                red i slično).
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava sadrži:</strong>
                <ul className="values-section">
                  <li>Istorijat i izvori diplomatskog i konzularnog prava</li>
                  <li>Bečka konvencija o diplomatskim odnosima iz 1961.</li>
                  <li>Organi međunarodnih odnosa</li>
                  <li>Diplomatski predstavnici</li>
                  <li>Članovi diplomatske misije</li>
                  <li>Šef diplomatske misije</li>
                  <li>Funkcije diplomatske misije</li>
                  <li>Status diplomatskog predstavništva</li>
                  <li>Diplomatske povlastice i imuniteti</li>
                  <li>Nepovredivost prostorija</li>
                  <li>Nepovredivost arhiva</li>
                  <li>Sloboda diplomatske korespondencije</li>
                  <li>Fiskalna i carinska izuzeća</li>
                  <li>Lićna nepovredivost diplomatskih predstavnika</li>
                  <li>Akreditovanje i imenovanje članova diplomatske misije</li>
                  <li>Počasni konzuli</li>
                  <li>Diplomatski kor</li>
                  <li>Unutrašnji organi države sa pravom predstavljanja</li>
                  <li>
                    Spoljašnji organi predstavljanja države na bilateralnoj
                    ravni
                  </li>
                  <li>Prestanak diplomatske misije</li>
                  <li>Specijalne misije</li>
                  <li>Razlika između diplomatske i konzularne službe</li>
                  <li>
                    Spoljašnji organi predstavljanja države na multilateralnoj
                    ravni
                  </li>
                  <li>Stalne misije pri međunarodnim organizacijama</li>
                  <li>Predstavljanje država putem organa drugih država</li>
                  <li>Službenici međunarodnih organizacija</li>
                  <li>
                    Privilegije i imuniteti organizacije i njenih službenika
                  </li>
                  <li>Privilegije i imuniteti Ujedinjenih nacija</li>
                  <li>Eksperti Ujedinjenih nacija</li>
                  <li>Međunarodna praksa</li>
                </ul>
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Interaktivna nastava, analiza slučajeva, seminarska nastava.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P+1V</td>
                    <td>
                      Istorijat i izvori diplomatskog i konzularnog prava; Bečka
                      konvencija o diplomatskim odnosima iz 1961.
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P+1V</td>
                    <td>
                      Organi međunarodnih odnosa; Diplomatski predstavnici
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P+1V</td>
                    <td>Članovi diplomatske misije; Šef diplomatske misije</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P+1V</td>
                    <td>
                      Funkcije diplomatske misije; Status diplomatskog
                      predstavništva
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P+1V</td>
                    <td>Diplomatske povlastice i imuniteti</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P+1V</td>
                    <td>
                      Nepovredivost prostorija; Nepovredivost arhiva; Sloboda
                      diplomatske korespondencije
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P+1V</td>
                    <td>
                      Fiskalna i carinska izuzeća; Lična nepovredivost
                      diplomatskih predstavnika
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P+1V</td>
                    <td>
                      Akreditovanje i imenovanje članova diplomatske misije;
                      Počasni konzuli; Diplomatski kor
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P+1V</td>
                    <td>Unutrašnji organi države sa pravom predstavljanja</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P+1V</td>
                    <td>
                      Spoljašnji organi predstavljanja države na bilateralnoj
                      ravni
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P+1V</td>
                    <td>
                      Prestanak diplomatske misije; Specijalne misije; Razlika
                      između diplomatske i konzularne službe
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P+1V</td>
                    <td>
                      Spoljašnji organi predstavljanja države na multilateralnoj
                      ravni; Stalne misije pri međunarodnim organizacijama
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P+1V</td>
                    <td>
                      Predstavljanje država putem organa drugih država;
                      Službenici međunarodnih organizacija; Privilegije i
                      imuniteti organizacije i njenih službenika; Privilegije i
                      imuniteti Ujedinjenih nacija; Eksperti Ujedinjenih nacija;
                      Međunarodna praksa
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default DiplomatskoIKonzularnoPravoPM;
